export const insightUrls = {
  insightsUrl: "/engagement/analytics",
};
